/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Conversation } from '../models/conversation';
import { conversationGetPromptSuggestionList } from '../fn/conversation/conversation-get-prompt-suggestion-list';
import { ConversationGetPromptSuggestionList$Params } from '../fn/conversation/conversation-get-prompt-suggestion-list';
import { conversationStartConversationWithDocuments } from '../fn/conversation/conversation-start-conversation-with-documents';
import { ConversationStartConversationWithDocuments$Params } from '../fn/conversation/conversation-start-conversation-with-documents';
import { conversationStartConversationWithOrganisation } from '../fn/conversation/conversation-start-conversation-with-organisation';
import { ConversationStartConversationWithOrganisation$Params } from '../fn/conversation/conversation-start-conversation-with-organisation';
import { conversationStartConversationWithSearch } from '../fn/conversation/conversation-start-conversation-with-search';
import { ConversationStartConversationWithSearch$Params } from '../fn/conversation/conversation-start-conversation-with-search';
import { conversationStartConversationWithVaults } from '../fn/conversation/conversation-start-conversation-with-vaults';
import { ConversationStartConversationWithVaults$Params } from '../fn/conversation/conversation-start-conversation-with-vaults';
import { PromptSuggestionList } from '../models/prompt-suggestion-list';

@Injectable({ providedIn: 'root' })
export class ConversationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `conversationGetPromptSuggestionList()` */
  static readonly ConversationGetPromptSuggestionListPath = '/conversation/{conversationId}/suggestion/list';

  /**
   * Get prompt suggestions for conversation.
   *
   * Get prompt suggestions for conversation including the given documents
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conversationGetPromptSuggestionList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationGetPromptSuggestionList$Response(params: ConversationGetPromptSuggestionList$Params, context?: HttpContext): Observable<StrictHttpResponse<PromptSuggestionList>> {
    const obs = conversationGetPromptSuggestionList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get prompt suggestions for conversation.
   *
   * Get prompt suggestions for conversation including the given documents
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `conversationGetPromptSuggestionList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationGetPromptSuggestionList(params: ConversationGetPromptSuggestionList$Params, context?: HttpContext): Observable<PromptSuggestionList> {
    const resp = this.conversationGetPromptSuggestionList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PromptSuggestionList>): PromptSuggestionList => r.body)
    );
  }

  /** Path part for operation `conversationStartConversationWithDocuments()` */
  static readonly ConversationStartConversationWithDocumentsPath = '/conversation/documents';

  /**
   * Create a new conversation with documents.
   *
   * Create a new conversation with the given documents and conversation name
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conversationStartConversationWithDocuments()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithDocuments$Response(params: ConversationStartConversationWithDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
    const obs = conversationStartConversationWithDocuments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new conversation with documents.
   *
   * Create a new conversation with the given documents and conversation name
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `conversationStartConversationWithDocuments$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithDocuments(params: ConversationStartConversationWithDocuments$Params, context?: HttpContext): Observable<Conversation> {
    const resp = this.conversationStartConversationWithDocuments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Conversation>): Conversation => r.body)
    );
  }

  /** Path part for operation `conversationStartConversationWithOrganisation()` */
  static readonly ConversationStartConversationWithOrganisationPath = '/conversation/organisation';

  /**
   * Create a new conversation with organisation.
   *
   * Create a new conversation with the given conversation name
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conversationStartConversationWithOrganisation()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithOrganisation$Response(params: ConversationStartConversationWithOrganisation$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
    const obs = conversationStartConversationWithOrganisation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new conversation with organisation.
   *
   * Create a new conversation with the given conversation name
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `conversationStartConversationWithOrganisation$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithOrganisation(params: ConversationStartConversationWithOrganisation$Params, context?: HttpContext): Observable<Conversation> {
    const resp = this.conversationStartConversationWithOrganisation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Conversation>): Conversation => r.body)
    );
  }

  /** Path part for operation `conversationStartConversationWithSearch()` */
  static readonly ConversationStartConversationWithSearchPath = '/conversation/search';

  /**
   * Create a new conversation with search.
   *
   * Create a new conversation with the given search and conversation name
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conversationStartConversationWithSearch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithSearch$Response(params: ConversationStartConversationWithSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
    const obs = conversationStartConversationWithSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new conversation with search.
   *
   * Create a new conversation with the given search and conversation name
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `conversationStartConversationWithSearch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithSearch(params: ConversationStartConversationWithSearch$Params, context?: HttpContext): Observable<Conversation> {
    const resp = this.conversationStartConversationWithSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Conversation>): Conversation => r.body)
    );
  }

  /** Path part for operation `conversationStartConversationWithVaults()` */
  static readonly ConversationStartConversationWithVaultsPath = '/conversation/vaults';

  /**
   * Create a new conversation with vaults.
   *
   * Create a new conversation with the given vaults and conversation name
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conversationStartConversationWithVaults()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithVaults$Response(params: ConversationStartConversationWithVaults$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
    const obs = conversationStartConversationWithVaults(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new conversation with vaults.
   *
   * Create a new conversation with the given vaults and conversation name
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `conversationStartConversationWithVaults$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  conversationStartConversationWithVaults(params: ConversationStartConversationWithVaults$Params, context?: HttpContext): Observable<Conversation> {
    const resp = this.conversationStartConversationWithVaults$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Conversation>): Conversation => r.body)
    );
  }

}
